import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs';
import { BaseDocument } from '../../../models/documents/document.model';

export interface DocumentUploadModalData {
	title?: string;
	uploadFn: (file: File) => Observable<BaseDocument>;
}

@Component({
	selector: 'app-document-upload-modal',
	templateUrl: './document-upload-modal.component.html',
	styleUrls: ['./document-upload-modal.component.scss']
})
export class DocumentUploadModalComponent implements OnInit {
	selectedFile: File | null = null;
	isUploading = false;
	title = 'Upload Document';

	private uploadFn: ((file: File) => Observable<BaseDocument>) | null = null;

	constructor(
		private dialogRef: DynamicDialogRef,
		private config: DynamicDialogConfig<DocumentUploadModalData>,
		private messageService: MessageService
	) {}

	ngOnInit(): void {
		if (this.config.data) {
			this.title = this.config.data.title || 'Upload Document';
			this.uploadFn = this.config.data.uploadFn;
		}
	}

	onFileSelect(event: any): void {
		if (event.files && event.files.length > 0) {
			this.selectedFile = event.files[0];
		}
	}

	onRemoveFile(): void {
		this.selectedFile = null;
	}

	canUpload(): boolean {
		return this.selectedFile !== null && !this.isUploading && this.uploadFn !== null;
	}

	onUpload(): void {
		if (!this.canUpload() || !this.selectedFile || !this.uploadFn) return;

		this.isUploading = true;

		this.uploadFn(this.selectedFile).subscribe({
			next: (document) => {
				this.messageService.add({
					severity: 'success',
					summary: 'Success',
					detail: 'Document uploaded successfully'
				});
				this.dialogRef.close({ uploaded: true, document });
			},
			error: (error) => {
				this.messageService.add({
					severity: 'error',
					summary: 'Error',
					detail: error.error?.message || 'Failed to upload document'
				});
				this.isUploading = false;
			}
		});
	}

	onCancel(): void {
		this.dialogRef.close({ cancelled: true });
	}

	formatFileSize(bytes: number): string {
		if (bytes === 0) return '0 Bytes';
		const k = 1024;
		const sizes = ['Bytes', 'KB', 'MB', 'GB'];
		const i = Math.floor(Math.log(bytes) / Math.log(k));
		return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
	}
}
